import script from "./UnderstandingCard.vue?vue&type=script&setup=true&lang=js"
export * from "./UnderstandingCard.vue?vue&type=script&setup=true&lang=js"

import "./UnderstandingCard.vue?vue&type=style&index=0&id=7278e54d&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7278e54d"]])

export default __exports__